import React, { Component } from 'react';
import '../myutils';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CardLink from './CardLink';
import { Redirect } from 'react-router';
import { configAPI } from '../config'
import PermPhoneMsg from '@material-ui/icons/PermPhoneMsg';
import AttachMoney from '@material-ui/icons/AttachMoney';
import Timer from '@material-ui/icons/Timer';
import List from '@material-ui/icons/List';
import DialerSip from '@material-ui/icons/DialerSip';
import IncomingCalls from '../res/IncomingCalls'
import ActiveCampaigns from '../res/ActiveCampaigns'
import TotalTemplates from '../res/TotalTemplates'
import Typography from '@material-ui/core/Typography'
import { translate } from 'react-admin';

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 10}px`,
  },
  paperTop: {
    padding: theme.spacing.unit * 4,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    margin: theme.spacing.unit * 2,
  },
  paper: {
    padding: theme.spacing.unit * 6,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    margin: theme.spacing.unit * 2,
  },
  divider: {
    margin: `${theme.spacing.unit * 5}px 0`,
  },
  icon: { float: 'right', width: 64, height: 64, padding: 16, color: '#31708f' },
  image: { float: 'right', height: 72, padding: 16, color: '#31708f' },

});

class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {image: '', totalTime:0}
  }

  componentDidMount() {
    var bg = require('../res/yemot.gif');
    if(!sessionStorage.B) return;
    const ReqGetSession = new Request(configAPI.api.prod + 'GetSession?token=' + sessionStorage.B.encodeDecode());
    fetch(ReqGetSession)
      .then(response => response.json())
      .then(session => {
        if (session.responseStatus === 'OK') {
          const ReqGetSession = new Request('https://www.call2all.co.il/ym/misc/GetImgReseller.php?Reseller='+session.creditFile);
          fetch(ReqGetSession)
            .then(resellerResponse => resellerResponse.json())
            .then(resellerJson => {
              if (resellerJson.YemotShApi === 'OK') this.setState({image:'https://'+resellerJson.url});
              else this.setState({image:bg});
            });
          
          this.setState({ units: Number((session.units).toFixed(1)) });
          this.setState({ userID: session.username, organization: session.organization });
          sessionStorage.setItem('userDID', session.username)
        } else return (<Redirect to="/route/to/redirect" />);
      });
      var currentTime = new Date()
      var month = currentTime.getMonth() + 1
      month='0'+month;
      month = month.slice(-2)
      var year = currentTime.getFullYear()
      var day = currentTime.getDate();
      day='0'+day;
      day = day.slice(-2);
      var date1 = year+'-'+month+'-01';
      var date2 = year+'-'+month+'-'+day;
      const request = new Request(configAPI.api.prod + '/GetIncomingSum?token=' + sessionStorage.B.encodeDecode()+'&from='+date1+'&to='+date2, {
        headers: new Headers({
          'Content-Type': 'text/json'
        }),
        method: 'GET'
      });
  
      fetch(request).then(response => { return response.json(); })
      .then(resp => {
          this.setState({totalTime:resp.direct});                      
      })
  
      // var date = year+'-'+month;
      // const RequestLog = new Request(configAPI.api.prod + '/DownloadFile?&path=ivr2:Log/LogFolderEnterExit-' + date + '.ymgr&token=' + sessionStorage.B.encodeDecode(), {
      //   headers: new Headers({
      //     'Content-Type': 'text/json'
      //   }),
      //   method: 'GET'
      // });
      // fetch(RequestLog).then(data => data.text())
      // .then(data => {
      //     if (data !== 'Requested file does not exist') {
      //       var pattern = /(\d+)$/gm;
      //       var totalTime = data.match(pattern).reduce(function(prev, num) {
      //         return prev + +num;
      //       }, 0);
      //       this.setState({totalTime:totalTime});    
      //     }
      // })
  }

  secToTime = (duration) => {
    var seconds = Math.floor((duration) % 60),
      minutes = Math.floor((duration / 60) % 60),
      hours = Math.floor(duration / (60 * 60));
  
    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;
  
    return hours + ":" + minutes + ":" + seconds;
  }

  render() {
    const { classes } = this.props;
    const { userID, organization, units } = this.state;
    return (
      <div style={{paddingTop:-100}}>
        <Grid container spacing={3} >
          <Grid item xs={12}>
            <CardLink title={'trans.UserID'} link={'/Profile/1'} titleData={userID} subtitle={'trans.organization'} subtitleData={organization} icon={<img src={this.state.image} className={classes.image} alt={''}/>}  className={classes.paperTop} variant={'display2'}/>
          </Grid>
          <Grid item xs={6}>
            <CardLink title={'trans.now_listening'} link={'/Softphone'} body={<Typography variant="display2"><IncomingCalls/></Typography>} icon={<DialerSip className={classes.icon} />}  className={classes.paper} />
          </Grid>
          <Grid item xs={6}>
            <CardLink title={'trans.active_campaigns'} link={'/ActiveCampaigns'} body={<Typography variant="display2"><ActiveCampaigns/></Typography>} icon={<PermPhoneMsg className={classes.icon} />}  className={classes.paper} />
          </Grid>
          <Grid item xs={4}>
            <CardLink title={'trans.monthly_duration'} titleData={<Typography variant="display2">
            {/* {this.secToTime(this.state.totalTime)} */}
            {this.state.totalTime}
            </Typography>} link={'/Statistics'} body={''} icon={<Timer className={classes.icon} />}  className={classes.paper} />
          </Grid>
          <Grid item xs={4}>
            <CardLink title={'trans.units_left'} titleData={<Typography variant="display2">{units}</Typography>} link={'/UnitsStatistics'} body={''} icon={<AttachMoney className={classes.icon} />}  className={classes.paper} />
          </Grid>
          <Grid item xs={4}>
            <CardLink title={'trans.templates_count'} titleData={<Typography variant="display2"><TotalTemplates/></Typography>} link={'/Templates'} body={''} icon={<List className={classes.icon} />}  className={classes.paper} />
          </Grid>
        </Grid>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(translate(Dashboard));